<h5 class="modal-title break-all">
  <icons-presenter *ngIf="resource | resourceIconsColors as iconColors"
                   [colors]="iconColors.colors"
                   [icons]="iconColors.icons">
  </icons-presenter>
  <span [style.color]="textColor"
        [title]="resource?.name + '.' + attribute?.name"
        class="ms-1">{{resource?.name}}.{{attribute?.name}}</span>
</h5>
